export default "__VITE_ASSET__TsEsgv2n__"